var e={headerOne:"headerOne",headerTwo:"headerTwo",headerThree:"headerThree",body:"body",caption:"caption",code:"code"};export{e as TEXT_FORMATS};
